import { StepShell, SectionGroup } from '../components/layout';
import { TextField, TextArea, SearchSelect, SelectField } from '../components/inputs';
import { CITIES, RELATIONS } from '../lists';

export default function ContactStep({ data, update, notes = {} }) {
  return (
    <StepShell
      eyebrow="Step 2 of 18"
      title="How we’ll reach you"
      lede="We will use your email for everything that matters — updates on your application, and the link back to this profile if you need it."
    >
      <div className="ob-grid2">
        <TextField
          id="phone"
          label="Phone"
          type="tel"
          inputMode="tel"
          autoComplete="tel"
          placeholder="03XXXXXXXXX"
          value={data.phone}
          note={notes.phone}
          onChange={(v) => update({ phone: v })}
        />

        <TextField
          id="email"
          label="Email"
          type="email"
          inputMode="email"
          autoComplete="email"
          placeholder="you@email.com"
          value={data.email}
          note={notes.email}
          onChange={(v) => update({ email: v })}
        />
      </div>

      <SectionGroup label="Login password">
        <p className="ob-hint" style={{ marginTop: -6 }}>
          Choose a password now. You will be able to log in once the programme team
          approves your profile.
        </p>
        <div className="ob-grid2">
          <TextField
            id="password"
            label="Password"
            type="password"
            autoComplete="new-password"
            placeholder="At least 8 characters"
            value={data.password || ''}
            note={notes.password}
            onChange={(v) => update({ password: v })}
          />
          <TextField
            id="password_confirm"
            label="Confirm password"
            type="password"
            autoComplete="new-password"
            placeholder="Repeat password"
            value={data.password_confirm || ''}
            note={notes.password_confirm}
            onChange={(v) => update({ password_confirm: v })}
          />
        </div>
      </SectionGroup>

      <TextArea
        id="address"
        label="Address"
        rows={2}
        maxLength={300}
        showCounter={false}
        placeholder="House #, Street, Area"
        value={data.address}
        note={notes.address}
        onChange={(v) => update({ address: v })}
      />

      <SearchSelect
        id="city"
        label="City"
        options={CITIES}
        placeholder="e.g. Lahore / Karachi / Islamabad"
        value={data.city}
        note={notes.city}
        onChange={(v) => update({ city: v })}
      />

      <SectionGroup label="Emergency contact">
        <p className="ob-hint" style={{ marginTop: -6 }}>
          Someone we can reach if we ever need to. We will not contact them for
          anything routine.
        </p>

        <TextField
          id="emergency_name"
          label="Their name"
          value={data.emergency_name}
          note={notes.emergency_name}
          onChange={(v) => update({ emergency_name: v })}
        />

        <div className="ob-grid2">
          <TextField
            id="emergency_phone"
            label="Their phone"
            type="tel"
            inputMode="tel"
            placeholder="03XXXXXXXXX"
            value={data.emergency_phone}
            note={notes.emergency_phone}
            onChange={(v) => update({ emergency_phone: v })}
          />

          <SelectField
            id="emergency_relation"
            label="Relationship to you"
            options={RELATIONS}
            placeholder="Choose one"
            value={data.emergency_relation}
            note={notes.emergency_relation}
            onChange={(v) => update({ emergency_relation: v })}
          />
        </div>
      </SectionGroup>
    </StepShell>
  );
}
